
export const User_Favorites_URL = `https://api.timstudio.se/api/User`;
export const MENU_URL = `https://api.timstudio.se/api/Menu`;
export const FILTERS_URL = `https://api.timstudio.se/api/Filters`;
export const PO_URL = `https://api.timstudio.se/api/PurchaseOrder/create`
export const USERS_URL_REGISTER = `https://api.timstudio.se/api/User/Register`;
export const USERS_URL_LOGIN = `https://api.timstudio.se/api/User/login`;

//export const LINKDB = 'http://localhost:3005'; //Development

//export const LINKDB = 'https://json-server-bun-drop.onrender.com';
//export const PO_URL = 'https://json-server-bun-drop.onrender.com/purchaseOrders'
//export const FILTERS_URL ='https://json-server-bun-drop.onrender.com/filters'
//export const USERS_URL = 'https://json-server-bun-drop.onrender.com/users'
//export const MENU_URL = process.env.REACT_APP_API_URL + "/api/Menu";
//export const MENU_URL = process.env.REACT_APP_API_URL + "/api/Menu";
 //export const MENU_URL = 'https://json-server-bun-drop.onrender.com/menu'
 //export const MENU_URL = `http://localhost:7082/api/Menu`;
 //export const User_Favorites_URL = 'https://json-server-bun-drop.onrender.com/userFavorites/'

